import React from 'react';
import { FormattedMessage } from 'react-intl';

export default ({ intl, form, onChange, ...props }) => (
    <div {...props}>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="text"
                    name="name"
                    placeholder={intl.formatMessage({
                        id: 'conferenceProgramForm.name',
                    })}
                    value={form.name}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="text"
                    name="company"
                    placeholder={intl.formatMessage({
                        id: 'conferenceProgramForm.company',
                    })}
                    value={form.company}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <div className="control">
                <input
                    className="input"
                    type="email"
                    name="email"
                    placeholder={intl.formatMessage({
                        id: 'conferenceProgramForm.email',
                    })}
                    value={form.email}
                    onChange={onChange}
                />
            </div>
        </div>
        <div className="field">
            <textarea
                className="textarea"
                name="subject"
                rows={3}
                placeholder={intl.formatMessage({
                    id: 'conferenceProgramForm.subject',
                })}
                value={form.subject}
                onChange={onChange}
            />
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/ConferenctProgramForm/components/Contacts.js